import React, { useState } from 'react';
import { Container, Grid, Typography, Accordion, AccordionSummary, AccordionDetails, Box } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';

const FAQSection = ({ t }) => {
    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <Box sx={{ paddingY: 4, pb: 15, mt: -10, background: 'white', borderTopLeftRadius: 75, borderTopRightRadius: 75 }}>
            <Container>
                <Grid container>
                    <Grid item xs={12}>
                        <Typography variant="h3" color='#f03093' sx={{ fontSize: { xs: '2.125rem', sm: '3rem' }, mb: 5, fontWeight: 'bold', textAlign: 'center' }}>
                            {t('faq_title')}
                        </Typography>
                    </Grid>

                    <Grid container justifyContent="center" sx={{ width: '100%' }}>
                        {[...Array(7)].map((_, index) => (
                            <Accordion
                                key={index}
                                elevation={0}
                                expanded={expanded === index}
                                onChange={handleChange(index)}
                                sx={{
                                    background: 'transparent',
                                    '&:before': {
                                        content: 'none',
                                    },
                                    width: { xs: '100%', sm: '80%' }
                                }}
                            >
                                <AccordionSummary
                                    expandIcon={
                                        <ExpandMore
                                            sx={{
                                                color: expanded === index ? 'primary.main' : '#5947a6'
                                            }}
                                        />
                                    }
                                    sx={{
                                        color: expanded === index ? 'primary.main' : '#5947a6',
                                        mb: expanded === index ? 0 : { xs: 0 }
                                    }}
                                >
                                    <Typography
                                        component="h2"
                                        variant="h6"
                                        sx={{
                                            fontSize: { xs: '1rem', md: '1.25rem' },
                                            lineHeight: { xs: '1.25rem', md: '1.5rem' },
                                            fontWeight: 'bold'
                                        }}>
                                        {t(`faq_question${index + 1}`)}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ pt: 0, pb: 2 }} >
                                    <Typography sx={{
                                        fontSize: { xs: '0.9rem', md: '1rem' },
                                        lineHeight: { xs: '1.25rem', md: '1.25rem' },
                                    }}>
                                        {t(`faq_answer${index + 1}`)}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Grid>
                </Grid>
            </Container>
        </Box>
    )
};

export default FAQSection;
